export default __webpack_public_path__ + "static/f10ec8c8b3481fe2fe9dcad3dfb57daa.png";